/**
 * wheelilbin — the skin.
 *
 * Dials (from DESIGN.md ## Dials — keep these in sync):
 *   VARIANCE  4 / 5   a night studio: one object, hairlines, mono figures
 *   MOTION    3 / 5   a camera and a drawing hand; nothing else moves
 *   DENSITY   3 / 5   dense spec bands and margins, darkness between them
 *
 * This file is the whole contract between the project and core. Everything
 * project-specific is reachable from here; nothing project-specific lives
 * anywhere else.
 *
 * What the contract refuses, and why (core validates at build AND at mount):
 *   - removing the footer            brand presence and the privacy link
 *   - public links to admin routes   disclosure risk, BRIEF §6
 *   - overriding the analytics beacon  the no-consent-banner legal position
 *   - bypassing the SEO head         crawlability and the Core Web Vitals budget
 *   - opting out of reduced motion   accessibility
 */

import { defineSkin } from '@remidus/web-core'

import blocks from './blocks'
import layout from './layout'
import motion from './motion'
import scene from './scene'

export default defineSkin({
  name: 'wheelilbin',

  dials: { variance: 4, motion: 3, density: 3 },

  scene,
  motion,
  blocks,
  ...(layout ? { layout } : {}),

  // Extra footer and header links. They may not point at admin surfaces —
  // the contract checks, and `make check` greps the built bundle as well.
  footerLinks: [],
  headerLinks: [],
})
